import React, { useState, useEffect } from 'react';
import { getEmailValidationError } from '../utils/formValidation';
import { Check, TriangleAlert } from 'lucide-react';

const SUCCESS_DISPLAY_MS = 1500;
const SUCCESS_FADE_MS = 300;

const EmailValidation = ({ email, onValidationChange }) => {
  const [isValid, setIsValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [successFading, setSuccessFading] = useState(false);

  useEffect(() => {
    const error = getEmailValidationError(email);

    if (!email) {
      setIsValid(false);
      setErrorMessage('');
      onValidationChange?.(false);
      return;
    }

    if (error) {
      setIsValid(false);
      setErrorMessage(error);
      onValidationChange?.(false);
      return;
    }

    setIsValid(true);
    setErrorMessage('');
    onValidationChange?.(true);
  }, [email, onValidationChange]);

  useEffect(() => {
    if (!isValid) {
      setShowSuccess(false);
      setSuccessFading(false);
      return;
    }

    setShowSuccess(true);
    setSuccessFading(false);

    const fadeTimer = setTimeout(
      () => setSuccessFading(true),
      SUCCESS_DISPLAY_MS - SUCCESS_FADE_MS
    );
    const hideTimer = setTimeout(() => {
      setShowSuccess(false);
      setSuccessFading(false);
    }, SUCCESS_DISPLAY_MS);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [isValid]);

  if (!email) {
    return null;
  }

  return (
    <div className="email-validation">
      {!isValid && errorMessage && (
        <div className="validation-error">
          <span className="error-icon" aria-hidden="true">
            <TriangleAlert size={16} strokeWidth={1.75} />
          </span>
          <span className="error-message">{errorMessage}</span>
        </div>
      )}
      {isValid && showSuccess && (
        <div className={`validation-success${successFading ? ' validation-success--fade-out' : ''}`}>
          <span className="success-icon" aria-hidden="true">
            <Check size={16} strokeWidth={2} />
          </span>
          <span className="success-message">Valid email address</span>
        </div>
      )}
    </div>
  );
};

export default EmailValidation;
